// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/material-symbols/MaterialIconsSharp-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/material-symbols/MaterialIconsSharp-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/material-symbols/MaterialSymbolsSharp-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/material-symbols/MaterialSymbolsSharp-Regular.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Material Symbols Sharp';
    font-style: normal;
    font-weight: 100 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("eot"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("ttf"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
    font-display: block;
}

.material-symbols-sharp {
    font-family: 'Material Symbols Sharp';
    font-weight: normal;
    font-style: normal;
    font-size: 22px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}

.material-symbols-sharp {
    vertical-align: middle;
}


`, "",{"version":3,"sources":["webpack://./src/css/material-symbols.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,oBAAoB;IACpB;;;0DAGsF;IACtF,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["@font-face {\r\n    font-family: 'Material Symbols Sharp';\r\n    font-style: normal;\r\n    font-weight: 100 700;\r\n    src: url(../assets/fonts/material-symbols/MaterialIconsSharp-Regular.woff2) format('woff2'),\r\n    url(../assets/fonts/material-symbols/MaterialIconsSharp-Regular.eot) format(\"eot\"),\r\n    url(../assets/fonts/material-symbols/MaterialSymbolsSharp-Regular.ttf) format(\"ttf\"),\r\n    url(../assets/fonts/material-symbols/MaterialSymbolsSharp-Regular.woff) format(\"woff\");\r\n    font-display: block;\r\n}\r\n\r\n.material-symbols-sharp {\r\n    font-family: 'Material Symbols Sharp';\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-size: 22px;\r\n    line-height: 1;\r\n    letter-spacing: normal;\r\n    text-transform: none;\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    word-wrap: normal;\r\n    direction: ltr;\r\n    -webkit-font-feature-settings: 'liga';\r\n    -webkit-font-smoothing: antialiased;\r\n}\r\n\r\n.material-symbols-sharp {\r\n    vertical-align: middle;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
